import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { MarketingCalendarPage } from "@/features/MarketingCalendar/MarketingCalendarPage";

const searchSchema = z.object({
  /** Reopens this campaign's panel on mount (back from a broadcast
   * editor, FOG-2494). */
  campaign: z.string().optional(),
  /** "YYYY-MM": keeps refresh/share on the viewed month (FOG-2538). The
   * page validates the value, so a hand-edited URL degrades gracefully. */
  month: z.string().optional(),
});

export const Route = createFileRoute("/_auth/marketing-calendar/$siteId/")({
  component: RouteComponent,
  validateSearch: zodValidator(searchSchema),
});

function RouteComponent() {
  const { siteId } = Route.useParams();
  const { campaign, month } = Route.useSearch();
  return (
    <MarketingCalendarPage
      siteId={siteId}
      initialCampaignId={campaign}
      initialMonth={month}
    />
  );
}
